import { Center } from '@/types/models'
import { Location } from '../../types/models/Location.model'
import { isNonEmptyArray } from '@/utils/checks'
import getLocationCoordinates from '../location/useCases/getLocationCoordinates'

interface GetPageLatLng {
  location: Location
  centerList: Center[]
}

type GetPageLatLngReturn =
  | {
      lat: number
      lng: number
    }
  | Record<string, never>

const getPageLatLng = ({
  location,
  centerList = []
}: GetPageLatLng): GetPageLatLngReturn => {
  const { lat, lng } = getLocationCoordinates(location)
  const locationHasCoords = !!lat && !!lng

  if (locationHasCoords) {
    return { lat, lng }
  }

  if (!isNonEmptyArray(centerList)) {
    return {}
  }

  const centerWithCoords = centerList.find(
    (center) =>
      center && center._geoloc && center._geoloc.lat && center._geoloc.lng
  )

  if (!centerWithCoords) {
    return {}
  }

  return {
    lat: centerWithCoords._geoloc.lat,
    lng: centerWithCoords._geoloc.lng
  }
}

export default getPageLatLng
